// extracted by mini-css-extract-plugin
export default {"listItem":"styles_listItem__tLvbr","link":"styles_link__of7sd","active":"styles_active__WbMIm","icon":"styles_icon__cefjQ","badge":"styles_badge__zW636"};